"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Scrutinizerci = function Scrutinizerci(props) {
  var color = props.color,
      size = props.size,
      others = _objectWithoutPropertiesLoose(props, ["color", "size"]);

  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 24 24"
  }, others), /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.86 0L6.877.06a6.139 6.127 0 0 0-3.744 2.508 6.36 6.36 0 0 0-1.357 2.64l-.12.553-.119.857c-.06.799-.06 1.351.12 1.471h5.275c.06 0-.186-.246-.186-.672 0-.738.252-.924.552-1.23.552-.426 2.945-.12 4.728-.246 2.448 0 4.602-.06 4.848-.12 2.7-.427 5.03-2.388 5.522-4.536.12-.547.12-1.105.06-1.165C22.396 0 21.417 0 14.858 0zM9.192 9.007c-3.758-.015-7.47 0-7.53.06-.126.126-.06.798.06 1.35a5.64 5.64 0 0 0 1.843 2.761 7.549 7.549 0 0 0 3.312 1.59c.366.126 1.044.126 4.597.126 4.236 0 4.915.06 5.22.24a1.842 1.836 0 0 1 .372.372c.18.24.181.307.181.979 0 .672-.066.732-.186 1.044a1.47 1.47 0 0 1-.426.366c-.186.12-.307.119-4.357.179-4.67 0-5.155 0-6.319.432a6.445 6.433 0 0 0-2.46 1.35c-1.164 1.039-1.842 2.203-1.962 3.428l.06.611a283.022 282.613 0 0 0 15.404 0l.492-.12a4.543 4.537 0 0 0 .737-.245l.367-.18a7.735 7.723 0 0 0 3.499-4.297 8.407 8.395 0 0 0-.373-6.061 8.527 8.521 0 0 0-2.328-2.88 6.937 6.925 0 0 0-2.394-.984c-.246-.06-4.051-.106-7.81-.121z"
  }));
};

Scrutinizerci.propTypes = {
  /**
   * Hex color or color name
   */
  color: _propTypes.default.string,

  /**
   * The size of the Icon.
   */
  size: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};
Scrutinizerci.defaultProps = {
  color: 'currentColor',
  size: '24'
};
var _default = Scrutinizerci;
exports.default = _default;